<template>
  <div id="storeAuth" class='sellCenter'>
    <div class="storeAuthBox">
      <div>
        <div class='title'>
           <el-page-header @back="goBack" content="企业认证"> </el-page-header>
            <el-button type="primary" size='mini' @click="submitForm('storeAuthForm')">提交申请资料</el-button>
       </div>
        </div>
        <div :style="{height:height-100+'px'}" class='formBox'>
          <el-form
            :model="storeAuthForm"
            ref="storeAuthForm"
            label-width="250px"
            size="mini"
            class="demo-storeAuthForm"
          >
            <div>
              <el-form-item label="企业类型:">
                <div class="addressFormItem">
                  <div class="addressFormInputItem">
                    <el-select v-model="storeAuthForm.type.value" @change='inputBlur' placeholder="请选择企业类型">
                      <el-option
                        v-for="(item) in storeType"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </div>
                  <span
                    v-if="storeAuthForm.type.warning"
                    class="warning"
                  >{{storeAuthForm.type.warning}}</span>
                </div>
              </el-form-item>

              <el-form-item label="省份:">
                <div class="addressFormItem">
                  <div class="addressFormInputItem">
                    <el-select @change='inputBlur' v-model="storeAuthForm.area_code.value" placeholder="请选择省份">
                      <el-option
                        v-for="(item) in city"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </div>
                  <span
                    v-if="storeAuthForm.area_code.warning"
                    class="warning"
                  >{{storeAuthForm.area_code.warning}}</span>
                </div>
              </el-form-item>
              <el-form-item v-if="storeAuthForm.type.value==3" label="所属肉联厂:">
                <div class="addressFormItem">
                  <div class="addressFormInputItem">
                    <el-select v-model="storeAuthForm.belong_sid.value"  @change='inputBlur' placeholder="请选择所属肉联厂">
                      <el-option
                        v-for="(item) in companyList"
                        :key="item.storeId"
                        :label="item.companyName"
                        :value="item.storeId"
                      ></el-option>
                    </el-select>
                  </div>
                  <span
                    v-if="storeAuthForm.belong_sid.warning"
                    class="warning"
                  >{{storeAuthForm.belong_sid.warning}}</span>
                </div>
              </el-form-item>

              <el-form-item label="店铺名称:">
                <div class="addressFormItem">
                  <div class="addressFormInputItem">
                    <el-input
                      v-model="storeAuthForm.s_name.value"
                      @blur="inputBlur"
                      placeholder="请输入店铺名称"
                    ></el-input>
                  </div>
                  <span
                    v-if="storeAuthForm.s_name.warning"
                    class="warning"
                  >{{storeAuthForm.s_name.warning}}</span>
                </div>
              </el-form-item>
              <el-form-item v-if="storeAuthForm.type.value!=3" label="企业名称:">
                <div class="addressFormItem">
                  <div class="addressFormInputItem">
                    <el-input
                      v-model="storeAuthForm.b_name.value"
                      @blur="inputBlur"
                      placeholder="请输入企业名称"
                    ></el-input>
                  </div>
                  <span
                    v-if="storeAuthForm.b_name.warning"
                    class="warning"
                  >{{storeAuthForm.b_name.warning}}</span>
                </div>
              </el-form-item>
              <el-form-item v-if="storeAuthForm.type.value!=3" label="企业地址:">
                <div class="addressFormItem">
                  <div class="addressFormInputItem">
                    <el-input
                      v-model="storeAuthForm.b_address.value"
                      @blur="inputBlur"
                      placeholder="请输入企业地址"
                    ></el-input>
                  </div>
                  <span
                    v-if="storeAuthForm.b_address.warning"
                    class="warning"
                  >{{storeAuthForm.b_address.warning}}</span>
                </div>
              </el-form-item>
              <el-form-item v-if="storeAuthForm.type.value!=3" label="仓库地址:">
                <div class="addressFormItem">
                  <div class="addressFormInputItem">
                    <el-input
                      v-model="storeAuthForm.p_address.value"
                      @blur="inputBlur"
                      placeholder="请输入仓库地址"
                    ></el-input>
                  </div>
                  <span
                    v-if="storeAuthForm.p_address.warning"
                    class="warning"
                  >{{storeAuthForm.p_address.warning}}</span>
                </div>
              </el-form-item>
              <el-form-item v-if="storeAuthForm.type.value!=3" label="登记证号:">
                <div class="addressFormItem">
                  <div class="addressFormInputItem">
                    <el-input
                      v-model="storeAuthForm.reg_id.value"
                      @blur="inputBlur"
                      placeholder="请输入登记证号"
                    ></el-input>
                  </div>
                  <span
                    v-if="storeAuthForm.reg_id.warning"
                    class="warning"
                  >{{storeAuthForm.reg_id.warning}}</span>
                </div>
              </el-form-item>
              <el-form-item v-if="storeAuthForm.type.value!=3" label="法人姓名:">
                <div class="addressFormItem">
                  <div class="addressFormInputItem">
                    <el-input
                      v-model="storeAuthForm.legal_name.value"
                      @blur="inputBlur"
                      placeholder="请输入企业法人姓名"
                    ></el-input>
                  </div>
                  <span
                    v-if="storeAuthForm.legal_name.warning"
                    class="warning"
                  >{{storeAuthForm.legal_name.warning}}</span>
                </div>
              </el-form-item>
              <el-form-item v-if="storeAuthForm.type.value!=3" label="法人证件号:">
                <div class="addressFormItem">
                  <div class="addressFormInputItem">
                    <el-input
                      v-model="storeAuthForm.identity_id.value"
                      @blur="inputBlur"
                      placeholder="请输入法人证件号"
                    ></el-input>
                  </div>
                  <span
                    v-if="storeAuthForm.identity_id.warning"
                    class="warning"
                  >{{storeAuthForm.identity_id.warning}}</span>
                </div>
              </el-form-item>
              <el-form-item label="业务联系人姓名:">
                <div class="addressFormItem">
                  <div class="addressFormInputItem">
                    <el-input
                      v-model="storeAuthForm.contacts_name.value"
                      @blur="inputBlur"
                      placeholder="请输入业务联系人姓名"
                    ></el-input>
                  </div>
                  <span
                    v-if="storeAuthForm.contacts_name.warning"
                    class="warning"
                  >{{storeAuthForm.contacts_name.warning}}</span>
                </div>
              </el-form-item>
              <el-form-item label="业务联系人电话:">
                <div class="addressFormItem">
                  <div class="addressFormInputItem">
                    <el-input
                      v-model="storeAuthForm.mobile_id.value"
                      @blur="inputBlur"
                      placeholder="请输入业务联系人电话"
                    ></el-input>
                  </div>
                  <span
                    v-if="storeAuthForm.mobile_id.warning"
                    class="warning"
                  >{{storeAuthForm.mobile_id.warning}}</span>
                </div>
              </el-form-item>
              <el-form-item v-if="storeAuthForm.type.value==3" label="外调白条需求:">
                <div class="addressFormItem">
                  <div class="addressFormInputItem">
                    <el-radio v-model="storeAuthForm.is_transfer.value" label="0">无</el-radio>
                    <el-radio v-model="storeAuthForm.is_transfer.value" label="1">有</el-radio>
                  </div>
                  <span
                    v-if="storeAuthForm.is_transfer.warning"
                    class="warning"
                  >{{storeAuthForm.is_transfer.warning}}</span>
                </div>
              </el-form-item>

              <!-- <el-form-item label="性别:">
                <div class="addressFormItem">
                  <div class="addressFormInputItem">
                    <el-radio v-model="storeAuthForm.sex.value" label="1">男</el-radio>
                    <el-radio v-model="storeAuthForm.sex.value" label="0">女</el-radio>
                  </div>
                  <span
                    v-if="storeAuthForm.sex.warning"
                    class="warning"
                  >{{storeAuthForm.sex.warning}}</span>
                </div>
              </el-form-item>-->
              <el-form-item v-if="storeAuthForm.type.value!=3" label="营业执照(清晰正面照):">
                <div class="addressFormItem">
                  <div class="addressFormInputItem">
                    <UploadFile @uploadSuccess="({url})=>uploadSuccess(url,1)" />
                  </div>
                  <span
                    v-if="storeAuthForm.business_img.warning"
                    class="warning"
                  >{{storeAuthForm.business_img.warning}}</span>
                </div>
              </el-form-item>
              <el-form-item
                v-if="(!((storeAuthForm.type.value==3)||(storeAuthForm.type.value==5)))"
                label="基本存款账户信息(开户许可证):"
              >
                <div class="addressFormItem">
                  <div class="addressFormInputItem">
                    <UploadFile @uploadSuccess="({url})=>uploadSuccess(url,2)"></UploadFile>
                  </div>
                  <span
                    v-if="storeAuthForm.bank_account_licence.warning"
                    class="warning"
                  >{{storeAuthForm.bank_account_licence.warning}}</span>
                </div>
              </el-form-item>
              <el-form-item :label="storeAuthForm.type.value==3?'签约合同证明:':'企业资格证书:'">
                <div class='renderInfo'>
                    {{renderInfo()}}
                </div>
                <div class="addressFormItem">
                  <div class="addressFormInputItem">
                    <UploadFile  :multitude='true' @uploadSuccess="({url})=>uploadSuccess(url,3)"></UploadFile>
                  </div>
                  <span
                    v-if="storeAuthForm.certImg.warning"
                    class="warning"
                  >{{storeAuthForm.certImg.warning}}</span>
                </div>
                
              </el-form-item>

              <el-form-item v-if="storeAuthForm.type.value!=3" label="法人身份证正面照:">
                <div class="addressFormItem">
                  <div class="addressFormInputItem">
                    <UploadFile @uploadSuccess="({url})=>uploadSuccess(url,4)"></UploadFile>
                  </div>
                  <span
                    v-if="storeAuthForm.id_card_front.warning"
                    class="warning"
                  >{{storeAuthForm.id_card_front.warning}}</span>
                </div>
              </el-form-item>
              <el-form-item v-if="storeAuthForm.type.value!=3" label="法人身份证反面照:">
                <div class="addressFormItem">
                  <div class="addressFormInputItem">
                    <UploadFile @uploadSuccess="({url})=>uploadSuccess(url,5)"></UploadFile>
                  </div>
                  <span
                    v-if="storeAuthForm.id_card_back.warning"
                    class="warning"
                  >{{storeAuthForm.id_card_back.warning}}</span>
                </div>
              </el-form-item>
            </div>
          </el-form>
        </div>
      </div>
    </div>

</template>
<script>
import PageSearchTitle from "@/components/components/PageSearchTitle";
import { newAddstoreAuth, queryCompanyListUrl, newAddStoreAuth,
newAddBelongAuth} from "@/api/api";
import city from "@/utils/city.js";
import { mapState } from "vuex";
export default {
  props:['height'],
  created() {
    this.city = city;
    this.queryCompanyList();
  },
  computed: {
    ...mapState(["userInfo"])
  },
  data() {
    return {
      //  case 5:
      //     return '个体户认证'
      //   case 2:
      //     return '肉联厂认证'
      //   case 3:
      //     return '个人店铺认证'
      //   case 4:
      //     return '养殖厂认证'
      //   case 1:
      //     return '商贸公司认证'
      //   case 6:
      //       return '饲料厂认证'
      //   case 7:
      //       return '动保厂认证'
      //   case 8:
      //       return '添加剂厂认证'
      active: 1,
      companyList: null,
      storeType: [
        { value: 1, label: "商贸公司认证" },
        { value: 2, label: "肉联厂认证" },
        { value: 3, label: "个人店铺认证" },
        { value: 4, label: "养殖厂认证" },
        { value: 5, label: "个体户认证" },
        { value: 6, label: "饲料厂认证" },
        { value: 7, label: "动保厂认证" },
        { value: 8, label: "添加剂厂认证" }
      ],
      storeAuthForm: {
        type: {
          value: "",
          reg: [{ rule: /\S/, info: "*请选择企业类型" }],
          warning: ""
        },
        area_code: {
          value: "",
          reg: [{ rule: /\S/, info: "*请选择省份" }],
          warning: ""
        },
        belong_sid: {
          value: "",
          reg: [{ rule: /\S/, info: "*请选择所属肉联厂" }],
          warning: ""
        },
        s_name: {
          value: "",
          reg: [{ rule: /\S/, info: "*请填写店铺名称" }],
          warning: ""
        },
        b_name: {
          value: "",
          reg: [{ rule: /\S/, info: "*请填写企业名称" }],
          warning: ""
        },
        b_address: {
          value: "",
          reg: [{ rule: /\S/, info: "*请填写企业地址" }],
          warning: ""
        },
        p_address: {
          value: "",
          reg: [{ rule: /\S/, info: "*请填写仓库地址" }],
          warning: ""
        },
        reg_id: {
          value: "",
          reg: [{ rule: /\S/, info: "*请填写登记证号" }],
          warning: ""
        },
        legal_name: {
          value: "",
          reg: [{ rule: /\S/, info: "*请填写法人姓名" }],
          warning: ""
        },
        identity_id: {
          value: "",
          reg: [{ rule: /\S/, info: "*请填写法人证件号" }],
          warning: ""
        },
        contacts_name: {
          value: "",
          reg: [{ rule: /\S/, info: "*请填写业务联系人姓名" }],
          warning: ""
        },
        mobile_id: {
          value: "",
          reg: [
            { rule: /\S/, info: "*请填写业务联系人电话" },
            { rule: /^1[3456789]\d{9}$/, info: "*业务联系人电话格式有误" }
          ],
          warning: ""
        },
        is_transfer: {
          value: "0",
          reg: null,
          warning: ""
        },

        business_img: {
          value: "",
          reg: [{ rule: /\S/, info: "*请上传营业执照" }],
          warning: ""
        },
        bank_account_licence: {
          value: "",
          reg: [{ rule: /\S/, info: "*请上传基本存款账户信息(开户许可证)" }],
          warning: ""
        },
        certImg: {
          value: "",
          reg:null,
          warning: ""
        },

        id_card_front: {
          value: "",
          reg: [{ rule: /\S/, info: "*请上传法人身份证正面照" }],
          warning: ""
        },
        id_card_back: {
          value: "",
          reg: [{ rule: /\S/, info: "*请上传法人身份证反面照" }],
          warning: ""
        }
      }
    };
  },
  methods: {
    goBack(){
      this.$router.go(-1)
    },
    renderInfo(){
      let type= this.storeAuthForm.type.value
         switch (type) {
      case 2:
        return '动物防疫条件合格证、定点屠宰证、食品生产许可证（可选）、食品经营许可证（可选)'
      case 1:
        return '食品经营许可证（可选），食品流通许可证（可选）'
      case 5:
        return '食品经营许可证（可选），食品流通许可证（可选）'
      case 4:
        return '动物防疫条件合格证、种畜禽生产经营许可证（可选）'
      case 6:
        return '饲料生产许可证'
      case 7:
        return 'GMP证书、兽药生产许可证、饲料添加剂生产许可证（可选）'
      case 8:
        return '饲料添加剂生产许可证'
    }
    return ''
    },
    queryCompanyList() {
      let url = queryCompanyListUrl;
      let data = {
        type: 2,
        status: 1,
        areaId: "",
        pageIndex: 0,
        pageSize: 999
      };
      console.log("data", data);
      let param = new URLSearchParams();
      for (var k in data) {
        param.append(k, data[k]);
      }
      this.$axios({
        method: "post",
        data: param,
        url
      })
        .then(res => {
          console.log(res);
          if (res.data.resultCode == 1) {
            this.companyList = res.data.data;
          } else {
            this.$alert(res.data.resultMsg);
          }
        })
        .catch(err => {
         this.$alert(JSON.stringify(err))
        });
    },
    submitForm(formName) {
      if (this.testForm(this.formateForm(this.storeAuthForm))) {
        this.addstoreAuth();
      }
    },
  
    inputBlur() {
      this.testForm(this.formateForm(this.storeAuthForm), 1);
    },

    //         front_img
    // reverse_img
    // hand_cardimg
    uploadSuccess(url, imgType) {
      if (imgType == 1) {
        this.storeAuthForm.business_img.value = url;
      } else if (imgType == 2) {
        this.storeAuthForm.bank_account_licence.value = url;
      } else if (imgType == 3) {
        this.storeAuthForm.certImg.value = url;
      } else if (imgType == 4) {
        this.storeAuthForm.id_card_front.value = url;
      } else if (imgType == 5) {
        this.storeAuthForm.id_card_back.value = url;
      }
      this.$nextTick(() => {
        this.inputBlur();
      });
    },
    addstoreAuth() {
      let url = this.storeAuthForm.type.value==3?newAddBelongAuth:newAddStoreAuth;
      let formData = {};

      let formateForm = this.formateForm(this.storeAuthForm);
      for (var k in formateForm) {
        formData[k] = formateForm[k].value;
      }

      let data = {
        access_token: this.userInfo.access_token,
        ...formData
      };

      console.log("data", data);
      console.log("data.length", data.length);
    
      let param = new URLSearchParams();
      for (var k in data) {
        param.append(k, data[k]);
      }
      this.$axios({
        method: "post",
        data: param,
        url
      })
        .then(res => {
          console.log(res);
          if (res.data.resultCode == 1) {
            this.$alert("企业认证已提交,审核结果将在三个工作日内反馈", {
              center: true,
              showClose: true,
              callback:(action)=>{
                this.$router.go(-1)
              }
            });
          } else {
            this.$alert(res.data.resultMsg);
          }
        })
        .catch(err => {
         this.$alert(JSON.stringify(err))
        });
    },
    getFrontCardImg({ url }) {
      //   alert(1);
    },
    formateForm(form) {
      let values = [];
      if (form.type.value) {
        if (
          form.type.value == 1 ||
          form.type.value == 2 ||
          form.type.value == 4 ||
          form.type.value == 6 ||
          form.type.value == 7
        ) {
          //商贸公司
          values = [
            "type",
            "area_code",
            "s_name",
            "b_name",
            "b_address",
            "p_address",
            "reg_id",
            "legal_name",
            "identity_id",
            "contacts_name",
            "business_img",
            "bank_account_licence",
            "certImg",
            "id_card_front",
            "mobile_id",
            "id_card_back"
          ];
        } else if (form.type.value == 5) {
          //个体户
          values = [
            "type",
            "area_code",
            "s_name",
            "b_name",
            "b_address",
            "p_address",
            "reg_id",
            "legal_name",
            "identity_id",
            "mobile_id",
            "contacts_name",
            "business_img",
            "certImg",
            "id_card_front",
            "id_card_back"
          ];
        } else if (form.type.value == 3) {
          // 个人店铺
          values = [
            "type",
            "area_code",
            "s_name",
            "belong_sid",
            "contacts_name",
            "mobile_id",
            "certImg",
            'is_transfer'
          ];
        }
        let newForm = {};
        for (var k in form) {
          if (
            values.some(item => {
              return item == k;
            })
          ) {
            newForm[k] = form[k];
          }
        }
        return newForm;
      } else {
        return form;
      }
    },
    getBackCardImg({ url }) {
      console.log(url);

      this.storeAuthForm.reverse_img.value = url;
      this.$nextTick(() => {
        this.inputBlur();
      });
    },
    getHandCardImg({ url }) {
      this.storeAuthForm.hand_cardimg.value = url;
      this.$nextTick(() => {
        this.inputBlur();
      });
    },
    testForm(form, type) {
      console.log("form", form);
      let flag = true;
      for (var k in form) {
        let { value, reg, warning } = form[k];
        if (reg) {
          if (type) {
            if (warning) {
              let showTips = [];
              reg.forEach(item => {
                console.log(1);
                if (!item.rule.test(value)) {
                  form[k].warning = item.info;
                  flag = false;
                  showTips.push(true);
                  console.log(k, value);
                } else {
                  showTips.push(false);
                }
              });
              console.log(showTips);
              showTips.every(item => item == false) && (form[k].warning = "");
            }
            //   alert(1)
          } else {
            // alert(2)
            let showTips = [];
            reg.forEach(item => {
              console.log(1);
              if (!item.rule.test(value)) {
                form[k].warning = item.info;
                flag = false;
                showTips.push(true);
                console.log(k, value);
              } else {
                showTips.push(false);
              }
            });
            console.log(showTips);
            showTips.every(item => item == false) && (form[k].warning = "");
          }
        }
      }
      return flag;
    }
  },
  components: {
    PageSearchTitle
  }
};
</script>

<style lang='less' scoped>

.addressInfoWayItems:hover  {
  cursor: pointer;
}
.renderInfo{
  font-size: 14px;
  color:#666;
}
.addressInfoWayItems:hover  {
  cursor: pointer;
}
  .addressFormInputItem  {
  width: 300px;
}

  .addressFormItem  {
  display: flex;
}
  .warning  {
  color: #f40;
  margin-left: 10px;
}

.addressTitle  {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 60px;
  background-color: yellow;
}
  .addressTitleLeft  {
  font-size: 16px;
  font-weight: 700;
}
  .first  {
  margin: 15px 0;
}
  .addressInfoTitle  {
  height: 30px;
  background-color: purple;
  line-height: 30px;
  font-size: 14px;
  font-weight: 700;
}
  .addressInfoWay  {
  height: 50px;
  background-color: pink;
  display: flex;
  align-items: center;
}
  .addressInfoWayItems  {
  width: 150px;
  height: 30px;
  box-sizing: border-box;
  margin-right: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  border: 1px solid #aaa;
}
 .checked  {
  border-color: #f40;
}
.title{
  font-size: 16px;
  font-weight: 700;
  color:#454545;
  margin-bottom: 30px;
  padding:10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.formBox{
  overflow: scroll;
  padding-bottom: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/Authen/StoreAuth.vue